import { useEffect, useState } from "react"
import { fetchApi } from "../../tools"

const OPTIONS_ARRAY_STR = ['DEPARTAMENTOS_INS']

export const useDepartamentosOptions = (url = '', headers = {}) => {
    const [departamentosOptions, setDepartamentosOptions] = useState([])
    useEffect(() => {
        const fetchData = async () => {
            try {
                const resArr = await Promise.all(OPTIONS_ARRAY_STR.map(opcion => fetchApi({
                    url: url + '/utils/busquedas',
                    headers,
                    content: { opcion }
                })))

                const newObj = OPTIONS_ARRAY_STR.reduce((acc, x, i) => {
                    acc[x.toLowerCase()] = resArr[i]
                    return acc
                }, {})

                setDepartamentosOptions(newObj)

            } catch(err) {
                console.log(err)
            }
        }

        fetchData()
    }, [])

    return departamentosOptions
}